<template>
  <section class="">
    <div
      class="px-4 mx-auto max-w-3xl lg:px-0"
      :class="[
        paddingTop === 'reduced' ? 'pt-0' : 'pt-12 lg:pt-16',
        paddingBottom === 'reduced' ? 'pb-6 lg:pb-6' : 'pb-12 lg:pb-16'
      ]"
    >
      <div class="">
        <article class="overflow-hidden rounded-xl border border-[#E0D5C5] bg-white">
          <div
            class="flex gap-3.5 items-center px-6 py-4 bg-gradient-to-r"
            :class="headerGradientClass"
          >
            <div class="flex justify-center items-center rounded-lg shrink-0 size-11">
              <span
                class="text-[37.8px] leading-[25.5px] text-white opacity-30 font-serif"
                v-html="number"
              />
            </div>

            <div class="min-w-0">
              <p
                v-if="eyebrow"
                class="text-xs tracking-[0.72px] text-[#E8F0E6] uppercase font-ww-regular"
                v-html="eyebrow"
              />
              <h3
                v-if="title"
                class="text-[20.8px] font-bold leading-[25.5px] text-white font-serif"
                v-html="title"
              />
            </div>
          </div>

          <div class="flex flex-col gap-5 px-6 pt-6 pb-6">
            <div
              v-if="introContent"
              class="text-[17px] leading-[25px] text-[#4A4A4A] font-ww-regular [&_p+p]:mt-5 [&_ul]:list-disc [&_ul]:ml-6 [&_u]:underline [&_sup]:text-[11px]"
              v-html="introContent"
            />

            <div
              v-if="quoteContent"
              class="pl-[26px] pr-[22px] pt-[26px] pb-[18px] w-full rounded-r-md border-l-4 border-[#2D5A27] bg-[#E8F0E6]"
            >
              <div
                class="text-[16.5px] leading-[29.7px] text-[#2D5A27] font-ww-bold"
                v-html="quoteContent"
              />
            </div>

            <div
              v-if="splitCards.length"
              class="grid grid-cols-1 gap-5 sm:grid-cols-2"
            >
              <div
                v-for="(card, index) in splitCards"
                :key="index"
                class="p-[26px] rounded-md border"
                :class="card.variant === 'green'
                  ? 'border-[#B8D8B4] bg-[#E8F0E6]'
                  : 'border-[#E0D5C5] bg-[#FAF6F0]'"
              >
                <p
                  class="text-[37.8px] leading-[25.5px] font-bold font-serif"
                  :class="card.variant === 'green' ? 'text-[#37736C]' : 'text-[#A07020]'"
                  v-html="card.value"
                />
                <p
                  class="mt-3.5 text-[15px] leading-[25.5px] text-[#4A4A4A] font-ww-regular"
                  v-html="card.text"
                />
              </div>
            </div>

            <div
              v-if="outroContent"
              class="text-[17px] leading-[25px] text-[#4A4A4A] font-ww-regular [&_p+p]:mt-5 [&_sup]:text-[11px]"
              v-html="outroContent"
            />

         

            <div
              v-if="sideContent"
              class="flex flex-col gap-6 lg:flex-row lg:gap-[25px] lg:items-start"
            >
              <div
                class="flex-1 min-w-0 text-[17px] leading-[25px] text-[#4A4A4A] font-ww-regular [&_p+p]:mt-5 [&_ul]:list-disc [&_ul]:ml-6 [&_u]:underline [&_sup]:text-[11px]"
                v-html="sideContent"
              />

              <div class="relative shrink-0 w-full max-w-[281px] mx-auto lg:mx-0">
                <nuxt-img
                  v-if="imageSrc"
                  :src="imageSrc"
                  :alt="imageAlt"
                  width="281"
                  height="350"
                  format="webp"
                  loading="lazy"
                  class="object-cover w-full h-[350px] rounded-[15px]"
                />
                <div
                  v-else
                  class="w-full h-[350px] rounded-[15px] bg-[#2A2A2A]"
                  aria-hidden="true"
                />
              </div>
            </div>

            <div
              v-if="tipsTitle || tipsContent"
              class="relative overflow-hidden pb-[23px] px-[27px] pt-[33px] rounded-b-lg border border-[#F1574B] border-t-[3px] bg-[#F0E8D8]"
            >
              <h4
                v-if="tipsTitle"
                class="flex gap-2.5 items-start text-lg font-bold text-[#3B2314] font-ww-bold"
              >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H4M12 3V4M20 12H21M5.6 5.6L6.3 6.3M18.4 5.6L17.7 6.3M9.7 17H14.3M9 16C8.16047 15.3704 7.54033 14.4925 7.22743 13.4908C6.91453 12.4892 6.92473 11.4144 7.25658 10.4189C7.58844 9.4233 8.22512 8.55739 9.07645 7.94379C9.92778 7.33019 10.9506 7 12 7C13.0494 7 14.0722 7.33019 14.9236 7.94379C15.7749 8.55739 16.4116 9.4233 16.7434 10.4189C17.0753 11.4144 17.0855 12.4892 16.7726 13.4908C16.4597 14.4925 15.8395 15.3704 15 16C14.6096 16.3865 14.3156 16.8594 14.1419 17.3806C13.9681 17.9018 13.9195 18.4566 14 19C14 19.5304 13.7893 20.0391 13.4142 20.4142C13.0391 20.7893 12.5304 21 12 21C11.4696 21 10.9609 20.7893 10.5858 20.4142C10.2107 20.0391 10 19.5304 10 19C10.0805 18.4566 10.0319 17.9018 9.85813 17.3806C9.6844 16.8594 9.39043 16.3865 9 16Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                <span v-html="tipsTitle" />
              </h4>

              <div
                v-if="tipsContent"
                class="text-[15.5px] leading-[27.13px] text-[#4A4A4A] font-ww-regular [&_p+p]:mt-0"
                :class="tipsTitle ? 'mt-2' : ''"
                v-html="tipsContent"
              />
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  number: {
    type: String,
    default: '01'
  },
  eyebrow: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  theme: {
    type: String,
    default: 'green',
    validator: (value) => ['green', 'brown', 'gold'].includes(value)
  },
  introContent: {
    type: String,
    default: ''
  },
  splitCards: {
    type: Array,
    default: () => []
  },
  outroContent: {
    type: String,
    default: ''
  },
  quoteContent: {
    type: String,
    default: ''
  },
  sideContent: {
    type: String,
    default: ''
  },
  imageSrc: {
    type: String,
    default: ''
  },
  imageAlt: {
    type: String,
    default: ''
  },
  tipsTitle: {
    type: String,
    default: ''
  },
  tipsContent: {
    type: String,
    default: ''
  },
  paddingTop: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'reduced'].includes(value)
  },
  paddingBottom: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'reduced'].includes(value)
  }
})

const headerGradientClass = computed(() => {
  switch (props.theme) {
    case 'brown':
      return 'from-[#3C2314] to-[#592C19]'
    case 'gold':
      return 'from-[#7C511D] to-[#C08F39]'
    default:
      return 'from-[#2E5B27] to-[#397731]'
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Numbered Guide Card',
  inputs: [
    {
      name: 'number',
      type: 'text',
      defaultValue: '01'
    },
    {
      name: 'eyebrow',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'title',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'theme',
      type: 'text',
      enum: ['green', 'brown', 'gold'],
      defaultValue: 'green'
    },
    {
      name: 'introContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'splitCards',
      type: 'list',
      defaultValue: [],
      subFields: [
        {
          name: 'value',
          type: 'text',
          defaultValue: ''
        },
        {
          name: 'text',
          type: 'longText',
          defaultValue: ''
        },
        {
          name: 'variant',
          type: 'text',
          enum: ['green', 'neutral'],
          defaultValue: 'green'
        }
      ]
    },
    {
      name: 'outroContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'quoteContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'sideContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'imageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: ''
    },
    {
      name: 'imageAlt',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'tipsTitle',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'tipsContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'paddingTop',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'default'
    },
    {
      name: 'paddingBottom',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'default'
    }
  ]
})
</script>
